<template>
    <div class="as-app-car-list as-app-car-list-results">
        <div class="as-app-list-results-header as-app-row">
            <div class="as-app-col as-app-col-12 hide-on-print"><a class="back-link" href="javascript:history.back()">&laquo;&nbsp;zurück</a></div>
            <div class="as-app-col as-app-col-12">
                <div class="as-app-search-results-title">Für Ihre Suchanfrage sind <span class="as-app-count">{{$store.state.resultsCountProxy}} Angebote</span>
                    verfügbar.
                </div>
            </div>
            <div class="as-app-col as-app-col-12">
                <div class="btn-ah-wrapper">
                    <a href="javascript:history.back()" class="btn-ah has-fa">Suche anpassen <font-awesome-icon :icon="['fas', 'pen']" /></a>
                </div>
            </div>
            <div class="as-app-col as-app-col-12">
                <SortOptions/>
            </div>
        </div>

        <div class="as-app-row">
            <div v-if="$apollo.queries.searchResults.loading && results.length === 0"></div><!--Just a helper-->
            <div v-else v-for="car in results" :key="car.id"
                 class="as-app-col as-app-col-12 as-app-col-xs-6 as-app-col-sm-6 as-app-col-md-4 as-app-car-col">
                <a :href="$store.state.detailsPath+encodeURIComponent('-b-' + $R.pathOr('',['details','vehicle','classification','make','raw'], car) + '-' + $R.pathOr('',['details','vehicle','classification','make','formatted'], car) + '-m-' + $R.pathOr('',['details','vehicle','classification','model','formatted'], car).replace(/[^A-Za-z0-9]/g,'') + '-guid-' + car.id + '-offerid-' + $R.pathOr('',['details','identifier','offerReference'], car))">
                    <div class="relative-height ar-420-315 overflow-visible">
                        <div class="relative-height-inner overflow-visible">
                            <img v-if="typeof car.details.media.images[0] !== 'undefined' && car.details.media.images[0].__typename === 'StandardImage'"
                                 :src="car.details.media.images[0].formats.jpg.size800x600"
                                 class="as-app-car-image relative-height-image">
                            <div v-if="car.id === $store.state.carOfTheWeekId" class="as-app-car-label">Auto der
                                Woche
                            </div>

                            <div v-else-if="((new Date() - new Date(car.details.publication.createdTimestampWithOffset)) / 86400000) < 14"
                                 class="as-app-car-label">Neu im Bestand
                            </div>
                        </div>
                    </div>
                    <div class="as-app-content-wrapper">
                        <!--{{car.id}}-->
                        <h4 class="as-app-car-title">{{$R.pathOr('-',['details','adProduct','title'], car)}}</h4>
                        <div class="as-app-price-table">
                            <span class="as-app-price">
                                  {{$R.pathOr('-',['details','prices','public','amountInEUR','formatted'], car)}}
                            </span>
                            <div class="as-app-price-rating au-widget-car-rating" data-enable-box-constraints data-layout="wide_without_price_with_explanation" data-theme="transparent" :data-car-url="$store.state.siteUrl+$store.state.detailsPath+encodeURIComponent('-b-' + $R.pathOr('',['details','vehicle','classification','make','raw'], car) + '-' + $R.pathOr('',['details','vehicle','classification','make','formatted'], car) + '-m-' + $R.pathOr('',['details','vehicle','classification','model','formatted'], car).replace(/[^A-Za-z0-9]/g,'') + '-guid-' + car.id + '-offerid-' + $R.pathOr('',['details','identifier','offerReference'], car))"></div>
                        </div>
                        <div class="as-app-details-table">
                            <div class="as-app-full-width">
                                <span>
                                    {{$R.pathOr('-',['details','vehicle','fuels','primary','co2emissionInGramPerKm', 'formatted'], car)}},
                                    <template v-for="label in $R.pathOr([],['details','vehicle','environment','environmentLabels'], car)">
                                        <template v-if="label.norm === 'EU_Directive_70_220_EEC_LDV'">{{label.label}}</template>
                                    </template>
                                </span>
                            </div>
                            <div class="as-app-full-width">
                                <span>
                                    {{_.round( $R.pathOr('-',['details','vehicle','fuels','primary','consumption','combined','raw'], car), 1)}}l/100km (komb),
                                    {{_.round( $R.pathOr('-',['details','vehicle','fuels','primary','consumption','urban','raw'], car), 1)}}l/100km (innerorts),
                                    {{_.round( $R.pathOr('-',['details','vehicle','fuels','primary','consumption','extraUrban','raw'], car), 1)}}l/100km (außerorts)
                                </span>
                            </div>
                            <div><span>{{$R.pathOr('-',['details','vehicle','condition','mileageInKm','formatted'], car)}}</span>
                            </div>
                            <div><span>{{$R.pathOr('-',['details','vehicle','condition','firstRegistrationDate','formatted'], car)}}</span>
                            </div>
                            <div><span>{{$R.pathOr('-',['details','vehicle','engine','power','kw','formatted'], car)}} ({{$R.pathOr('-',['details','vehicle','engine','power','hp','formatted'], car)}})</span>
                            </div>
                            <div><span>{{$R.pathOr('-',['details','vehicle','fuels','primary','source'], car)}}</span>
                            </div>
                            <div>
                                <span>{{$R.pathOr('-',['details','vehicle','condition','numberOfPreviousOwnersExtended','formatted'], car)}}</span>
                            </div>
                            <div>
                                <span>{{$R.pathOr('-',['details','vehicle','legalCategories','0','formatted'], car)}}</span>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>
        <div v-if="$apollo.queries.searchResults.loading" class="as-app-spinner load-more">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
        </div>
        <div v-if="pageInt*12 < this.$store.state.resultsCountProxy" class="btn-ah-wrapper text-center">
            <button @click="pageInt++" class="btn-ah has-fa">Mehr Autos Anzeigen <font-awesome-icon :icon="['fas', 'sync']" /></button>
        </div>
    </div>
</template>

<script>
    /*global auWidgetEmbed, auWidgetConfig, window */
    import Vue from 'vue'
    import SortOptions from '@/components/SortOptions.vue'

    export default {
        name: 'list',
        components: {
            SortOptions
        },
        data() {
            return {
                resultsArray: [],
            }
        },
        methods: {},
        computed: {
            results: {
                get() {
                    return this.resultsArray
                },
                set(val) {
                    this.resultsArray = val
                }
            },
            pageInt: {
                get() {
                    return this.$store.state.searchParams.pageIntProxy
                },
                set(val) {
                    this.$store.commit('updateSearchParams', {pageIntProxy: val === 'null' ? 1 : val}) //Build object that will be merged into state.searchParams
                }
            }
        },
        mounted: function () {
            // console.log('yiha');
            // this.$apollo.queries.searchResults.start()
            this.$store.commit('updateSearchParams', {pageIntProxy: 1})
            window.auWidgetConfig = {sourceName: 'Autohäuser Pohlheim'}
            let s=document.createElement('script')
            s.async=true
            s.src='//www.autouncle.de/widgets/embed.js?source_name='+encodeURIComponent(auWidgetConfig.sourceName)
            s.setAttribute('data-source-name',auWidgetConfig.sourceName)
            s.id='au-widget-script'
            let h=document.getElementsByTagName('head')[0]
            h.insertBefore(s,h.lastChild)
        },
        apollo: {
            /////////////////////////////////
            // Get Results based in Inputs //
            /////////////////////////////////

            searchResults: {
                query: require('../graphql/SearchResults.gql'),
                errorPolicy: 'all',
                // fetchPolicy: 'no-cache',
                manual: true,
                // skip: true,
                variables() {
                    // Use vue reactive properties here
                    return {
                        withListings: true,
                        makeId: this.$store.state.searchParams.makeIdProxy,
                        modelId: this.$store.state.searchParams.modelIdProxy,
                        bodyTypeEnum: this.$store.state.searchParams.bodyTypeEnumProxy === null ? [] : this.$store.state.searchParams.bodyTypeEnumProxy,
                        gearingEnum: this.$store.state.searchParams.gearingEnumProxy === null ? [] : this.$store.state.searchParams.gearingEnumProxy,
                        fuelEnum: this.$store.state.searchParams.fuelEnumProxy === null ? [] : this.$store.state.searchParams.fuelEnumProxy, //if errors occur make sure the full enumArray is provided instead of [] by changing it to this.getFuelsEnumArray()
                        emissionClassEnum: this.$store.state.searchParams.emissionClassEnumProxy === null ? null : this.$store.state.searchParams.emissionClassEnumProxy,
                        powerFromInt: this.$store.state.searchParams.powerFromIntProxy,
                        powerToInt: this.$store.state.searchParams.powerToIntProxy,
                        firstRegistrationFromInt: this.$store.state.searchParams.firstRegistrationFromIntProxy,
                        firstRegistrationToInt: this.$store.state.searchParams.firstRegistrationToIntProxy,
                        mileageFromInt: this.$store.state.searchParams.mileageFromIntProxy,
                        mileageToInt: this.$store.state.searchParams.mileageToIntProxy,
                        priceFromInt: this.$store.state.searchParams.priceFromIntProxy,
                        priceToInt: this.$store.state.searchParams.priceToIntProxy,
                        offerTypeEnum: this.$store.state.searchParams.offerTypeEnumProxy,
                        bodyColorEnum: this.$store.state.searchParams.bodyColorEnumProxy,
                        upholsteryEnum: this.$store.state.searchParams.upholsteryEnumProxy,
                        equipmentEnum: this.$store.state.searchParams.equipmentEnumProxy,
                        sortByEnum: this.$store.state.searchParams.sortObjectProxy.sortBy,
                        sortOrderEnum: this.$store.state.searchParams.sortObjectProxy.sortOrder,
                        pageInt: this.$store.state.searchParams.pageIntProxy,
                        aMakeIdOne: this.$store.state.searchParams.makeIdProxy === 999999 ? 9 : null, // Audi
                        aMakeIdTwo: this.$store.state.searchParams.makeIdProxy === 999999 ? 13 : null, //BMW
                        aMakeIdThree: this.$store.state.searchParams.makeIdProxy === 999999 ? 16360 : null, //Dacia
                        aMakeIdFour: this.$store.state.searchParams.makeIdProxy === 999999 ? 29 : null, // Ford
                        aMakeIdFive: this.$store.state.searchParams.makeIdProxy === 999999 ? 31 : null, // Honda
                        aMakeIdSix: this.$store.state.searchParams.makeIdProxy === 999999 ? 39 : null, // Kia
                        aMakeIdSeven: this.$store.state.searchParams.makeIdProxy === 999999 ? 46 : null, // Mazda
                        aMakeIdEight: this.$store.state.searchParams.makeIdProxy === 999999 ? 47 : null, // Mercedes
                        aMakeIdNine: this.$store.state.searchParams.makeIdProxy === 999999 ? 16338 : null, // Mini
                        aMakeIdTen: this.$store.state.searchParams.makeIdProxy === 999999 ? 54 : null, // Opel
                        aMakeIdEleven: this.$store.state.searchParams.makeIdProxy === 999999 ? 55 : null, // Peugeot
                        aMakeIdTwelve: this.$store.state.searchParams.makeIdProxy === 999999 ? 57 : null, // Porsche
                        aMakeIdThirteen: this.$store.state.searchParams.makeIdProxy === 999999 ? 70 : null, // Toyota
                        aMakeIdFourteen: this.$store.state.searchParams.makeIdProxy === 999999 ? 73 : null // Volvo
                    }
                },
                error(error) {
                    // console.log({error})
                    if(parseInt(error.networkError.statusCode) === 429){
                        Vue.logApiLimitReached();
                    }
                },
                result(data) {
                    if (typeof data.error === 'undefined' && typeof data.data !== 'undefined' && !data.loading) {
                        // console.log(data);
                        let self = this
                        // console.log('Changed', this.$store.state.sortChanged);
                        if (!this.$store.state.sortChanged) {
                            data.data.search.listings.listings.forEach(function (listing) {
                                self.resultsArray.push(listing)
                            })
                        } else {
                            self.resultsArray = data.data.search.listings.listings;
                        }

                        self.resultsArray = Vue.filterImagesInResultsArray(self.resultsArray);

                        // console.log('RESULTS!');
                        // console.log(self.resultsArray);
                        this.$store.commit('updateResultsCount', data.data.search.listings.metadata.totalItems)
                        // console.log(this.results);
                        this.$store.commit('onResultsFinished')
                        this.$nextTick(() => {
                            if(typeof auWidgetEmbed !== 'undefined' && typeof auWidgetEmbed.init !== 'undefined'){
                                auWidgetEmbed.init()
                            }
                        })
                    }
                }
            },
        }
    }
</script>
<style scoped lang="scss">
    @import "../styles/style";

    @import "../styles/partials/_car-list";
    @import "../styles/partials/_car-list-results";
</style>